import React, { Component } from 'react'
import { connect } from 'react-redux'
import { languageSwitchItem } from '../actions/locales'
import i18next from 'i18next'
import { createSession, sendInputData, sendSessionOption, sendKeyContainer, decryptData,
			getDecryptedData, deleteSession, getDecryptorStatus } from '../actions/api'
import { setInputFileForDecrypt, clearInputFileForDecrypt, setDecryptedData, clearDecryptedData, setDecryptEncodingType,
		    setInputTextForDecryptUintArr, setInputTextForDecrypt, setDecryptText, clearDecryptText, clearInputTextForDecryptUintArr,
		    clearInputTextForDecrypt } from '../actions/localStates'
import { StringToUTF16LEArray, fromByteArray, StringToArray, toByteArray, UTF16LEArrayToString, ArrayToString } from '../actions/stringEncodersFuncs'
import { bindActionCreators } from 'redux';

class DecryptTextContainer extends Component {

	constructor(props) {
    super(props);

	    this.state = {
			isLoading: false,
			uuid: null,
			downloadIsAvailable: true
		}

		this.textEncodingHendler = this.textEncodingHendler.bind(this)
		this.textInputHendler = this.textInputHendler.bind(this)
	}

	buildFileForDecryptSelector(){
		const fileForDecrypt = document.getElementById('fileForDecryptUpload');
		return fileForDecrypt;
	}

	componentDidMount(){
    	this.fileForDecrypt = this.buildFileForDecryptSelector();
	}

	textEncodingHendler(e) {
		this.props.actions.setDecryptEncodingType(e.target.value)
	}

	handleFileForDecrypt(e) {
	    e.preventDefault();
	    this.fileForDecrypt.value = null;
	    this.fileForDecrypt.click()
	    document.activeElement.blur()
	}

	textInputHendler(e) {
		this.props.actions.setInputTextForDecrypt(e.target.value)
		// this.props.actions.clearDSDataBase64()
	}

	cleanUpFileForDecrypt(){
		this.props.actions.clearInputFileForDecrypt()
		this.props.actions.clearDecryptedData()
	}

	cleanUpForm(){
		this.props.actions.clearDecryptText()
		this.props.actions.clearInputTextForDecryptUintArr()
		this.props.actions.clearInputTextForDecrypt()
	}

	getBlobData() {
		var _this = this
	    var saveBlob = (function () {
	        var a = document.createElement("a");
	        document.body.appendChild(a);
	        a.style.cssText = "display: none";
	        return function (blob, fileName) {
	        	if (navigator.appVersion.toString().indexOf('.NET') > 0) {
	        		var name = fileName.lastIndexOf(".") < 2 ? fileName : fileName.substr(0, fileName.lastIndexOf("."));
		            window.navigator.msSaveBlob(blob, name);
		            
		       } else {
		           var url = window.URL.createObjectURL(blob);
		            a.href = url;
		            a.download = fileName.lastIndexOf(".") < 2 ? fileName : fileName.substr(0, fileName.lastIndexOf("."));
		            a.click();
		            window.URL.revokeObjectURL(url);

			    }
			    window.setTimeout(function () {
			    	_this.setState({downloadIsAvailable: true})
			    }, 1000)
	        };
	    }());

	    this.setState({downloadIsAvailable: false})
	    saveBlob(this.props.defaultDecrState.decrData, this.props.defaultDecrState.fileForDecryptName);
	}

	decrypt() {
		var arr, dsArr, _this = this

		this.props.defaultState.textEncoding === 'UTF-16LE'
			? arr = this.props.actions.StringToUTF16LEArray(this.props.defaultState.textForDecrypt, false)
			: arr = this.props.actions.StringToArray(this.props.defaultState.textForDecrypt, true)

		try {
            var u8Arr = new Uint8Array(arr);
			this.props.actions.setInputTextForDecryptUintArr(u8Arr)

			dsArr = this.props.actions.toByteArray(this.props.defaultState.textForDecrypt)
			var u8DSArr = new Uint8Array(dsArr);
        } catch (e) {
            alert(i18next.t("ds:illegalBase64SignatureFormat"));
            return;
        }
		

		this.setState({isLoading: true})
		this.props.actions.createSession(this.props.connectionStatus.baseUrl)
        	.then((response) => {
				this.setState({uuid: response.ticketUuid})
				console.log(response);
			return this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, u8DSArr)
            	.then(() => this.props.actions.decryptData(this.props.connectionStatus.baseUrl, this.state.uuid))
	            .then(() => this.props.actions.getDecryptedData(this.props.connectionStatus.baseUrl, this.state.uuid))
	           	.then((response) => {
	           		if (response !== null && response.message === undefined) {
	            		var reader = new FileReader();
		                reader.onload = function () {
		                    var arrayBuffer = reader.result;
		                    var uintArray = new Uint8Array(arrayBuffer);
		                    var arr = [].slice.call(uintArray);
		                    var s = _this.props.defaultState.textEncoding === 'UTF-16LE'
		                    	? _this.props.actions.UTF16LEArrayToString(arr)
		                    	: _this.props.actions.ArrayToString(arr)
		                    _this.props.actions.setDecryptText(s)
		                }
		                reader.readAsArrayBuffer(response);
            		}
            		this.setState({isLoading: false})
                })
                .then(() => this.props.actions.getDecryptorStatus(this.props.connectionStatus.baseUrl, this.state.uuid))
                .then((response) => {
	           		if (response.failureCause !== undefined && response.failureCause.length > 0) {
	           			alert(response.failureCause)
	           		}
                })
	            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
        })
    }

	render() {
		const isEnabled = this.props.defaultState.textForDecrypt.length > 0

		return (
			<div>
            <div className="row" style={{paddingTop: "10px"}}>
				<div className="col-12">
	                <div className="card">
						<div className="card-header">
							{i18next.t("textData": "textData")}
						</div>
	                  	<div className="card-body">
	                  		<div className="form">
	                    		<label>{i18next.t("encoding": "encoding")}</label>
	                    		<div className="form-check-inline">
		                            <label className="form-check-label" style={{marginLeft: "7px"}}>
		                                <input className="form-check-input" value="UTF-16LE" type="radio" checked={this.props.defaultState.textEncoding === 'UTF-16LE'} onChange={this.textEncodingHendler}/>
		                                <span className="form-check-label">{i18next.t("utf16LeEncoding" : "utf16LeEncoding")}</span>
		                            </label>
		                            <label className="form-check-label" style={{marginLeft: "7px"}}>
		                                <input className="form-check-input" value="UTF-8" type="radio" checked={this.props.defaultState.textEncoding === 'UTF-8'} onChange={this.textEncodingHendler} />
		                                <span className="form-check-label">{i18next.t("utf8Encoding" : "utf8Encoding")}</span>
		                            </label>
			                    </div>
	                    	</div>
	                    	<div>
	                    		<label>{i18next.t("dec:encryptedBase64DataTitle": "encryptedBase64DataTitle")}</label>
		                        <div className="input-group mb-4">
									<textarea id="dscTextForDs" rows="3" className="form-control" value={this.props.defaultState.textForDecrypt} onInput={this.textInputHendler}></textarea>
								</div>
	                    	</div>
							<button className="btn btn-default" onClick={this.decrypt.bind(this)} disabled={!isEnabled}>{i18next.t("dec:performBinaryDataDecryption": "performBinaryDataDecryption")}
								{
	                                this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
	                                : null
	                            }
							</button>
	                        <button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
	                        <div style={{"paddingTop": "15px"}}>
								<label>{i18next.t("dec:decryptedTextBase64Title": "decryptedTextBase64Title")}</label>
								<textarea id="dscDsBase64" rows="3" className="form-control" value={this.props.defaultState.decryptText} readOnly></textarea>
							</div>
	                    </div>
	                </div>  
                </div>
            </div>
        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        pkLocalState: state.privateKeyReducer,
        defaultState: state.decryptTextReducer,
        connectionStatus: state.connectionStatusReucer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    createSession,
	    sendInputData,
	    sendSessionOption,
	    sendKeyContainer,
	    decryptData,
	    getDecryptedData,
	    deleteSession,
	    setInputFileForDecrypt,
	    clearInputFileForDecrypt,
	    setDecryptedData,
	    clearDecryptedData,
	    getDecryptorStatus,
	    setDecryptEncodingType,
	    setInputTextForDecryptUintArr,
	    setInputTextForDecrypt,
	    StringToUTF16LEArray, fromByteArray, StringToArray, toByteArray,
	    setDecryptText,
	    UTF16LEArrayToString,
	    ArrayToString,
	    clearDecryptText,
	    clearInputTextForDecryptUintArr,
	    clearInputTextForDecrypt
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DecryptTextContainer);


// WEBPACK FOOTER //
// ./src/containers/DecryptTextContainer.js